<template>
  <div class="relative flex-container d-flex flex-column ai-center">
    <div
      class="section-wrapper d-flex flex-column relative"
      v-bind:class="{ 'mg-150': !isMobile, 'mg-50': isMobile }"
    >
      <div class="news-mask" />
      <div class="header-2 color-white">News</div>

      <div
        class="news-wrap flex-container"
        v-bind:class="{
          'mg-150': !isMobile,
          'mg-50': isMobile,
          'd-flex flex-column': isMobile,
        }"
      >
        <div v-if="!news" class="flex-container center">
          <v-progress-circular color="#1c1c1c" indeterminate />
        </div>
        <template v-else>
          <div class="flex-1 news-nav">
            <template v-for="(item, index) in news.entries()">
              <div
                class="flex-container text-2 bold pa-2 nav-item"
                :key="`cate-${index}`"
                v-bind:class="{ 'nav-active': selected === item[0] }"
                @click="onClickNav(item[0])"
              >
                <div class="flex-1 category-text">
                  {{ item[0] }}
                  <div v-if="!isMobile" class="ml-auto">
                    {{ item[1].length }}
                  </div>
                </div>
                <div v-if="!isMobile" class="flex-1" />
              </div>
            </template>
          </div>
          <div v-if="isMobile" class="mg-50" />
          <div class="flex-3 news-container">
            <template v-if="news">
              <div
                v-for="(item, index) in getCurrentPage()"
                class="news-card flex-container"
                :key="`body-${index}`"
                @click="onClickNews(item.id)"
              >
                <img
                  class="news-thumbnail"
                  v-if="JSON.parse(item.images).length > 0"
                  :src="JSON.parse(item.images)[0].url"
                />
                <img
                  class="news-thumbnail"
                  v-else
                  :src="require('../assets/thumb_default.jpg')"
                />

                <div class="flex-3 flex-container d-flex flex-column pa-3">
                  <div class="news-header">
                    <p class="header-caption color-grey">
                      {{
                        `${item.category.name} | ${item.author} | ${item.timestamp}`
                      }}
                    </p>
                    <p class="text-1 bold">
                      {{
                        isMobile ? getShort(item.title) : parseTitle(item.title)
                      }}
                    </p>
                  </div>
                  <div class="text-2 color-grey news-body">
                    {{
                      isMobile
                        ? getShort(item.summary)
                        : parseSummary(item.summary)
                    }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="mg-50" />
      <div v-if="page" class="flex-container center">
        <div
          class="btn-prev ma-2"
          v-bind:class="{ disabled: page === 1 }"
          @click="prevPage"
        />
        <div v-for="index in pageLimit" :key="`pagination-${index}`">
          <div v-if="page === index" class="page-index text-1 bold ma-2">
            {{ index }}
          </div>
          <div
            v-else
            class="page-index text-1 color-grey bold ma-2"
            @click="setPage(index)"
          >
            {{ index }}
          </div>
        </div>
        <div
          class="btn-next ma-2"
          v-bind:class="{ disabled: page === pageLimit }"
          @click="nextPage"
        />
      </div>
    </div>
    <div class="mg-50" />
  </div>
</template>

<script>
export default {
  data: () => ({
    selected: "All",
    news: null,
    page: null,
    pageLimit: null,
  }),
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  methods: {
    async parseData() {
      const response = await this.$apollo.query({
        query: require("../graphql/GetPublishedNews.gql"),
      });

      const ok = response.data.GetPublishedNews.ok;
      if (!ok) {
        alert("서버 에러");
        return [];
      }
      let rawNews = response.data.GetPublishedNews.news;

      rawNews = rawNews.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );

      const map = new Map();

      map.set("All", rawNews);

      for (const news of rawNews) {
        const key = news.category.name;
        const collection = map.get(key);
        if (collection) {
          collection.push(news);
        } else {
          map.set(key, [news]);
        }
      }

      this.page = 1;
      this.pageLimit = Math.ceil(rawNews.length / 5);
      this.news = map;
    },
    getShort(text) {
      if (text.length < 20) {
        return text;
      } else {
        return text.substring(0, 17) + "...";
      }
    },

    parseTitle(title) {
      if (title.length < 50) {
        return title;
      }
      return title.substring(0, 47) + "...";
    },

    parseSummary(summary) {
      if (summary.length < 75) {
        return summary;
      }
      return summary.substring(0, 72) + "...";
    },
    getCurrentPage() {
      let start = (this.page - 1) * 5;
      let end = this.page * 5;
      const limit = this.news.get("All").length;
      if (end > limit) end = limit;
      return this.news.get(this.selected).slice(start, end);
    },
    nextPage() {
      if (this.page === this.pageLimit) return;
      this.page++;
    },
    prevPage() {
      if (this.page === 1) return;
      this.page--;
    },
    setPage(page) {
      this.page = page;
    },
    onClickNav(label) {
      this.selected = label;
      this.page = 1;
      this.pageLimit = Math.ceil(this.news.get(label).length / 5);
    },
    onClickNews(id) {
      this.$router.push(`/news/${id}`);
    },
  },
  mounted() {
    this.parseData();
  },
};
</script>

<style scoped>
.news-mask {
  position: absolute;
  top: -5px;
  left: -850px;
  z-index: -1;
  height: 60px;
  width: 1000px;
  background: black;
}

.news-wrap {
  border-left: 1px solid grey;
}

.news-nav {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.nav-item {
  color: #898989;
  transition: 0.3s ease-in-out;
  z-index: 3;
  margin-left: -1px;
  cursor: pointer;
}

.nav-item:hover {
  transition: 0.3s ease-in-out;
  color: black;
  border-left: 2px solid black;
}

.nav-active {
  border-left: 2px solid black;
  color: black;
  cursor: initial;
}

.category-text {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
}

.news-container {
  height: 675px;
}

.news-card {
  border: 1px solid #f0f0f0;
  height: 125px;
  cursor: pointer;
}

.news-thumbnail {
  height: 125px;
  width: 180px;
  object-fit: cover;
}

.news-header {
  border-left: 2px solid black;
  padding-left: 12px;
}

.news-header > p {
  margin-bottom: 0;
}

.header-caption {
  margin-bottom: 10px !important;
  font-size: 12px;
}

.news-body {
  margin-top: 10px;
  margin-left: 14px;
}

@media only screen and (max-width: 880px) {
  .news-mask {
    position: absolute;
    top: -5px;
    left: -950px;
    z-index: -1;
    height: 30px;
    background: black;
  }

  .category-text {
    justify-content: center;
    align-items: center;
  }

  .news-wrap {
    border-top: 1px solid grey;
    border-left: none;
  }

  .news-nav {
    -ms-flex-direction: row;
    -webkit-flex-direction: row;
    flex-direction: row;
  }

  .nav-item {
    color: #898989;
    transition: 0.3s ease-in-out;
    z-index: 3;
    margin-left: 0;
    margin-top: -1px;
    cursor: pointer;
  }

  .nav-item:hover {
    transition: 0.3s ease-in-out;
    color: black;
    border-top: 2px solid black;
    border-left: none;
  }

  .nav-active {
    border-top: 2px solid black;
    border-left: none;
    color: black;
    cursor: initial;
  }

  .news-thumbnail {
    height: 100px;
    width: 80px;
  }

  .header-caption {
    margin-bottom: 6px !important;
    font-size: 6px;
  }

  .news-body {
    margin-top: 5px;
  }

  .news-card {
    border: 1px solid #f0f0f0;
    height: 100px;
    cursor: pointer;
  }
}
</style>
